import { isNil, isObject, isString } from 'lodash';
import { hostedStylesVersion } from 'mainConfig';

export const validateSource = (source) => {
    if (['vector', 'raster'].indexOf(source) === -1) {
        throw new Error('Source must be "vector" or "raster".');
    }

    return source;
};

export const validateWmsFormat = (format) => {
    if (['jpeg', 'png'].indexOf(format) === -1) {
        throw new Error('Format must be "jpeg" or "png".');
    }

    return format;
};

export const styleValidatorFactory = (styleMappings) => {
    return (source, styleName) => {
        const retrievedStyleName = styleMappings[source][styleName];

        if (isNil(retrievedStyleName)) {
            const validStyleNamesList = Object.keys(styleMappings[source]).join(', ');
            throw new Error(`Style name must be one of ${validStyleNamesList}.`);
        }

        return retrievedStyleName;
    };
};

export const isStylePlainObject = (style) => isObject(style) && !isString(style);

export const validateVersion = (version, source) => {
    if (version === '1') {
        return source === 'vector' ? hostedStylesVersion : undefined;
    }

    throw new Error('Version must have value of "1"');
};



// WEBPACK FOOTER //
// ./map/configurer/styleOptionInitialization/validators.js